import { ShareConfigButton } from "@src/components/crud-explore/share-config-button";
import { IntelligenceFormFieldsEnum } from "../../enum";
import { DuplicateConfigButton } from "@src/components/crud-explore/duplicate-config-button";
import { ModalSave, ModeSave } from "@src/components/intelligence-search/crud-component/modal-save";
import React from "react";
import { Form } from "antd";
import { getUserInfo } from "@src/util/get-user-info";
import { FormInstance } from "antd/lib";
import { isFormMultipleConfigChange } from "@src/util/intelligence-search/crud/is-form-multiple-config-change";
import { PERMISSION_LAYOUT_CHECK } from "@src/components/crud-permission-layout";
import { useBlockNavigateUnSave } from "@src/hooks/use-block-navigate-unsave";

export type InitConfig = {
    id?: string;
    isPublic?: boolean;
    owner?: string;
    title: string;
    description: string;
    productCode?: string;
};
type HandleSaveFunctionType = (values: { title: string; description: string }, mode?: ModeSave) => Promise<void>;

export const CrudActionButton: React.FC<{
    form: FormInstance<any>;
    isCreate?: boolean;
    handleSave: HandleSaveFunctionType;
    initConfigProps?: Record<string, any>;
    modalValuesProps: {
        title: string;
        description: string;
    };

    isOwnerConfig?: boolean;
}> = ({
    handleSave,
    isCreate = false,
    initConfigProps,
    form,
    modalValuesProps: modalValues,
    isOwnerConfig = false,
}) => {
    const { setWarnWhen } = useBlockNavigateUnSave();
    const [open, setOpen] = React.useState(false);

    const formWatch = Form.useWatch([], form);
    const productCodeWatch = formWatch?.[IntelligenceFormFieldsEnum.PRODUCT_CODE];

    const initConfig: InitConfig = {
        title: modalValues?.title ?? "",
        description: modalValues?.description ?? "",
        owner: initConfigProps?.owner ?? "",
        productCode: initConfigProps?.product_code ?? "",
        id: initConfigProps?.id?.toString() ?? "",
        isPublic: initConfigProps?.is_public ?? false,
    };

    const handleActionConfirm = () => {
        return handleSave(modalValues);
    };

    const isConfigChanging =
        isCreate ||
        isFormMultipleConfigChange(initConfigProps?.config ?? {}, formWatch ?? {}) ||
        JSON.stringify({
            title: modalValues?.title,
            description: modalValues?.description,
        }) !==
            JSON.stringify({
                title: initConfigProps?.title,
                description: initConfigProps?.description,
            });

    React.useEffect(() => {
        if (isCreate) {
            setWarnWhen(!!productCodeWatch);
        } else {
            setWarnWhen(isConfigChanging);
        }
    }, [isConfigChanging, setWarnWhen, isCreate, productCodeWatch]);

    const isDisabled = !isConfigChanging;
    const initMode = isOwnerConfig ? "save" : "save-as-new";

    return (
        <div className={`flex space-x-2 items-center ${PERMISSION_LAYOUT_CHECK}`}>
            {isOwnerConfig && (
                <>
                    <ShareConfigButton
                        page="intelligence-searches"
                        handleClick={() => {
                            return handleActionConfirm();
                        }}
                        hasConfigChanged={isConfigChanging}
                        isPublic={initConfig?.isPublic ?? false}
                        productCode={productCodeWatch}
                    />
                    <DuplicateConfigButton
                        handleClick={() => {
                            return handleActionConfirm();
                        }}
                        hasConfigChanged={isConfigChanging}
                        page="intelligence-searches"
                    />
                </>
            )}

            <ModalSave
                initMode={initMode}
                initValues={{
                    title: initConfig?.title ?? "",
                    description: initConfig?.description ?? "",
                }}
                isDisabled={isDisabled}
                isOwnerConfig={isOwnerConfig}
                type={isCreate ? "create" : "edit"}
                open={open}
                setOpen={setOpen}
                saveOptions={{
                    onOk: (values, mode) => {
                        return handleSave(values, mode);
                    },
                }}
            />
        </div>
    );
};
